import React, { useCallback, useEffect, useState } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import dayjs from 'dayjs'

import { selectLocaleDict } from 'features/locale/selectors'

import { addNotify } from 'components/Notify'

interface IQrCodeTimerProps {
  expirationDate: number
  className: string
  handleClear?: { (): void }
}

const QrCodeTimer: React.FC<IQrCodeTimerProps> = ({ expirationDate, className, handleClear }) => {
  const locale = useSelector(selectLocaleDict, shallowEqual).payment

  const [residualTime, setResidualTime] = useState({
    hours: '00',
    minutes: '00',
    seconds: '00',
  })

  const startTimer = useCallback(() => {
    const dateEnd = dayjs(expirationDate)
    let currentDate = dayjs(Date.now())

    const hoursDifference = Math.trunc(dateEnd.diff(currentDate, 'hour', true))

    currentDate = currentDate.add(hoursDifference, 'hours')

    const minutesDifference = Math.trunc(dateEnd.diff(currentDate, 'minutes'))

    currentDate = currentDate.add(minutesDifference, 'minutes')

    const secondDifference = Math.trunc(dateEnd.diff(currentDate, 'seconds'))
    if (hoursDifference === 0 && minutesDifference === 0 && secondDifference === 0 && handleClear) {
      handleClear()
      addNotify(locale.expiredDeposit, 'warn')
    }

    setResidualTime({
      hours: hoursDifference < 10 ? `0${hoursDifference}` : `${hoursDifference}`,
      minutes: minutesDifference < 10 ? `0${minutesDifference}` : `${minutesDifference}`,
      seconds: secondDifference < 10 ? `0${secondDifference}` : `${secondDifference}`,
    })
  }, [expirationDate, handleClear, locale])

  useEffect(() => {
    const timer = setInterval(() => {
      startTimer()
    }, 250)

    return () => {
      clearInterval(timer)
    }
  }, [startTimer])

  return <span className={className}>{` ${residualTime.hours}:${residualTime.minutes}:${residualTime.seconds}`}</span>
}

export { QrCodeTimer }
